import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useFavorites } from "@/lib/favorites";

export const FavoriteButton = ({ spotId, className = "", withLabel = false }) => {
  const { isFav, toggle } = useFavorites();
  const fav = isFav(spotId);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const added = toggle(spotId);
    toast.success(added ? "Ajouté à vos favoris" : "Retiré de vos favoris");
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`favorite-btn-${spotId}`}
      aria-pressed={fav}
      title={fav ? "Retirer des favoris" : "Ajouter aux favoris"}
      className={`flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur text-rose-600 font-semibold transition-transform duration-200 hover:scale-110 active:scale-95 ${withLabel ? "px-4 py-2 text-sm" : "p-1.5"} ${className}`}
    >
      <Heart className={`w-4 h-4 transition-colors ${fav ? "fill-rose-500 text-rose-500" : ""}`} />
      {withLabel && (fav ? "Favori" : "Ajouter aux favoris")}
    </button>
  );
};
